/** localStorage key for Apollo cache (scoped by GraphQL endpoint). */
export function getApolloPersistStorageKey(graphqlUrl: string): string {
  return `apollo-cache-processing-webapp:${graphqlUrl}`;
}
